import { useNuxtApp, useRoute } from "#app";
import get from "lodash-es/get";
import clone from "lodash-es/clone";
export function getFieldsFromTemplate(template) {
  if (template === null)
    return [];
  const regex = /{{(.*?)}}/g;
  const fields = template.match(regex);
  if (!Array.isArray(fields)) {
    return [];
  }
  return fields.map((field) => {
    return field.replace(/{{/g, "").replace(/}}/g, "").trim();
  });
}
export const useSeoFields = (collectionName) => {
  const { $SEOAdvanceConfig } = useNuxtApp();
  const route = useRoute();
  const lang = route.params?.lang ?? "vi";
  let collectionSetting = {};
  collectionSetting = get($SEOAdvanceConfig, `${collectionName}.${lang}`, {});
  collectionSetting = clone(collectionSetting);
  let fields = [];
  Object.keys(collectionSetting)?.forEach((item) => {
    if (collectionSetting?.[item] && "string" === typeof collectionSetting?.[item]) {
      getFieldsFromTemplate(collectionSetting[item])?.forEach((field) => fields.push(field));
    }
  });
  return fields;
};
